import React, { useContext } from 'react';
import Urls from 'Utils/urls';
import { UiContext } from 'States/ui/uiState';
import CustomFooter from 'Components/shared/Custom/CustomFooter';
import i18nextTranslate from 'Lang/i18nextTranslate';
import { i18nextKeys } from 'Lang/i18nextKeys';

const Welcome = () => {
  const {
    breakpoints: { md }
  } = useContext(UiContext);

  return (
    <div
      className='flex flex-col items-center justify-between w-full min-h-full pb-20'
      style={{
        paddingLeft: md ? "30px" : "0px"
      }}
    >
      {/* fonts are larger than letters so line-height needs adaptation via 'leading-none' */}
      <div
        className='h-full w-full flex justify-center items-center'
        style={{
          backgroundImage: `url(${Urls.get()?.blob}/images/landing.jpg)`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          fontFamily: "Gelasio, sans-serif",
          fontSize: md ? "65px" : "27px",
          lineHeight: "44px",
          fontWeight: "bold",
          color: "#fdfdff",
          textShadow: "0 -1px 1px #000000a3, 0 5px 4px #000",
          height: "840px",
          backgroundAttachment: "fixed",
          backgroundPosition: "50%"
        }}
      >
        {i18nextTranslate(i18nextKeys.customLandingHeading)}
      </div>
      <CustomFooter />
    </div>
  );
};

export default Welcome;
